// Indian calendar-day maths. A trial or subscription is valid THROUGH its end
// date, so "days left" is a difference of calendar days, not of instants.
const DAY_MS = 24 * 60 * 60 * 1000;
const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

export const istDay = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? null : Math.floor((ms + IST_OFFSET_MS) / DAY_MS);
};

export const istToday = () => Math.floor((Date.now() + IST_OFFSET_MS) / DAY_MS);

/** Whole calendar days from today to `value` (0 = today, negative = past). */
export const daysLeft = (value) => {
  const day = istDay(value);
  return day === null ? null : day - istToday();
};
